/**
 * Utilitário padronizado de semanas para todo o aplicativo.
 * Padrão: Semana começa Domingo, termina Sábado (dia do encontro).
 * Numeração: Semana 1 = semana do 1o sábado do ano (mesmo padrão da Agenda).
 */

/** Retorna o primeiro sábado do ano */
export function getFirstSaturday(year) {
  const jan1 = new Date(year, 0, 1, 12, 0, 0);
  const daysToSat = (6 - jan1.getDay() + 7) % 7;
  return new Date(year, 0, 1 + daysToSat, 12, 0, 0);
}

/** Dado um date string (YYYY-MM-DD), retorna o sábado da semana Dom-Sáb */
export function getSaturdayOfWeek(dateStr) {
  const dt = new Date(dateStr + 'T12:00:00');
  const daysToSat = (6 - dt.getDay()) % 7;
  const sat = new Date(dt);
  sat.setDate(sat.getDate() + daysToSat);
  return sat.toISOString().split('T')[0];
}

/** Dado um sábado (YYYY-MM-DD), retorna o número da semana no ano */
export function getWeekNumber(saturdayStr) {
  const sat = new Date(saturdayStr + 'T12:00:00');
  const firstSat = getFirstSaturday(sat.getFullYear());
  const diffDays = Math.round((sat - firstSat) / 86400000);
  return Math.floor(diffDays / 7) + 1;
}

/** Dado qualquer date string (YYYY-MM-DD), retorna o número da semana */
export function getWeekNumberForDate(dateStr) {
  return getWeekNumber(getSaturdayOfWeek(dateStr));
}

/** Dado weekNum e ano, retorna { sunday: Date, saturday: Date } */
export function getWeekRange(weekNum, year) {
  const firstSat = getFirstSaturday(year || new Date().getFullYear());
  const saturday = new Date(firstSat);
  saturday.setDate(firstSat.getDate() + (weekNum - 1) * 7);
  const sunday = new Date(saturday);
  sunday.setDate(saturday.getDate() - 6);
  return { sunday, saturday };
}

/** Retorna o número da semana atual */
export function getCurrentWeekNum() {
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  return getWeekNumberForDate(todayStr);
}
